// MUI
import { useGridApiRef } from "@mui/x-data-grid-premium";

// Components
import CommonToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";

export default function OemVolvoEmployees(props) {
	const apiRef = useGridApiRef();

	return (
		<DataSmartTable
			apiRef={apiRef}
			columns={props.columns || []}
			rows={props.data || []}
			headerHeight={40}
			rowHeight={25}
			enableCustomScrollbars
			hideFooter
			disableColumnMenu
			disableRowSelectionOnClick
			disableMultipleRowSelection
			checkboxSelection={false}
			columnVisibilityModel={{
				_id: false,
				Rank: false,
				"Sample Size": false,
				"# of records": false,
				"Overall Satisfaction": true,
				"Overall NPS": false,
				"Process Index": false,
				"PST Process (PSTP)": false,
				"Right First Time In Time (RFTIT)": false,
				"Customer Service": false,
				Facilities: false,
				"After Handover/Service Contact": false,
				"Vehicle Booking": false,
				"Workshop Visit": false,
				"Car Dropped off with": false,
				"Offered to Wait": false,
				"Promptness of Answering Calls and Emails": false,
				"Quality of Maintenance/Repair": false,
				Convenience: false,
				"Information Provided": false,
				"Car Ready at Agreed Time": false,
				"All agreed work complete": false,
				"Follow up Contact After Maintenance/Repair": false,
				"Time from report to return": false,
				"Ability to keep time frame": false,
				"Courtesy car matching expectation": false,
				"Additional service": false,
				"Staff show car": false,
				"Agreed work completed": false,
				"Insurance company satisfaction": false,
				"Ease of insurance claim": false,
				"Sales Person showed an Honest and Genuine Interest": false,
				"Opinion about Sales Person's Knowledge": false,
				Understanding: false,
				"Follow up After Initial Offer": false,
				"Purchase Agreement": false,
				"Features and Controls Explanation": false,
				Cleanliness: false,
				"Follow up Contact After Delivery ": false,
				"Introduced to PST": false,
				"Delivered at the time agreed": false,
				"After Handover Contact": false,
				"Test Drive": false,
				"Booking Experience": false,
				"Driving Location Experience": false,
				"Driving Experience": false,
				"Right/Interested Car": false,
				"Follow up Contact After Delivery": false,
				referenceType: false,
			}}
			slots={{
				toolbar: CommonToolbar,
				noRowsOverlay: NoRowsOverlay,
			}}
			slotProps={{
				toolbar: {
					filter: {
						hide: false,
					},
					search: {
						data: props.data || [],
						hide: false,
						disabled: false,
					},
				},
				noRowsOverlay: {
					title: "No Employees Metrics data",
				},
			}}
			customProps={{
				tableContainerStyle: { height: "100%", width: "100%" },
				tableClassName: {
					"functional-table": true,
				},
				hide: false,
			}}
		/>
	);
}
